<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper" @click.self="$emit('close')">
        <PopupPanel dark class="modal-container">
          <PopupHeader class="modal-header">
            <h3>Reset your password</h3>

            <slot name="header">
              <PopupClose
                type="button"
                aria-label="Close password reset"
                @click="$emit('close')"
                class="icon"
              />
            </slot>
          </PopupHeader>

          <div class="modal-body">
            <slot name="body">
              <div class="logo">
                <img src="@/assets/logo-n.svg" alt="Nvoko Logo" />
              </div>
              <div class="form-container" v-if="!success">
                <form @submit.prevent="submit" novalidate>
                  <div class="inputs">
                    <div class="form-group">
                      <label for="email">Email address</label
                      ><input
                        v-model="email"
                        @blur="touched = true"
                        :aria-invalid="touched && !validEmail"
                        aria-describedby="reset-feedback"
                        autocomplete="email"
                        id="email"
                        type="email"
                        class="text-input dark"
                        placeholder="Enter your email"
                      />
                    </div>
                  </div>
                  <button
                    type="submit"
                    class="primary"
                    :disabled="!validEmail || submitting"
                  >
                    {{ submitting ? "Loading..." : "Submit" }}
                  </button>
                  <p id="reset-feedback" role="status" class="reset-feedback">
                    {{
                      error ||
                        (touched && !validEmail
                          ? "Enter a valid email address, such as name@example.com."
                          : "")
                    }}
                  </p>
                </form>
              </div>
              <div class="success" v-else>
                <div class="check">
                  <img src="../../assets/icons/Check.svg" />
                </div>
                <span
                  >If an account exists for that email, you’ll receive a
                  password reset link. Check your inbox and spam folder.</span
                >
              </div>
            </slot>
          </div>
        </PopupPanel>
      </div>
    </div>
  </transition>
</template>

<script>
import { normalizeEmail } from "@/utils/normalizeEmail";

import RESET_PASSWORD_REQUEST from "@/api/mutations/RESET_PASSWORD_REQUEST.gql";

export default {
  name: "ForgotPassword",
  components: {},
  data() {
    return {
      email: null,
      submitting: false,
      success: false,
      touched: false,
      error: ""
    };
  },
  computed: {
    validEmail() {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test((this.email || "").trim());
    },
    user() {
      return this.$store.getters["account/getUser"];
    }
  },
  methods: {
    async submit() {
      this.touched = true;
      if (!this.validEmail || this.submitting) return;
      this.error = "";
      try {
        this.submitting = true;
        const {
          data: { reset_password_request }
        } = await this.$apollo.mutate({
          mutation: RESET_PASSWORD_REQUEST,
          variables: { email: normalizeEmail(this.email) }
        });
        if (!reset_password_request) throw new Error("Missing reset response");
        this.success = true;
      } catch (e) {
        this.error = "We couldn’t request a reset. Please try again.";
      } finally {
        this.submitting = false;
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../../styles/_mixins.scss";
.modal-body {
  padding: 34px 200px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .logo {
    margin-bottom: 32px;
  }
  .form-container {
    width: 100%;
    h3 {
      color: $white;
      text-align: center;
    }
    form {
      margin-top: 40px;
      margin-bottom: 8px;
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .inputs {
        width: 100%;
        .form-group {
          margin-bottom: 30px;
          input {
            @include details-light();
            color: $white;
          }
        }
      }
      button {
        font-weight: 500;
        font-size: 16px;
        line-height: 24px;
        letter-spacing: -0.22px;
        padding: 10px 30px 12px;
      }
    }
  }
  .success {
    padding-top: 3rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .check {
      width: 60px;
      height: 60px;
      border-radius: 50%;
      background-color: $accent;
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        width: 30px;
        height: 30px;
      }
    }
    span {
      margin-top: 2rem;
      font-size: 1.3rem;
      color: $white;
      text-align: center;
    }
  }
}
.modal-container {
  width: min(480px, calc(100vw - 32px));
  height: auto;
}
.modal-body {
  padding: 24px 32px 32px;
  color: #fff;
}
.reset-feedback {
  color: #ffb7cc;
  margin-top: 16px;
  font-size: 14px;
  line-height: 1.5;
}
label {
  display: block;
  margin-bottom: 8px;
}
</style>
